import { Box, Typography } from "@mui/material";
import styles from "./Profile.module.css";
import { customTextColor, formatDate, formatTime } from "../../utils/const";
import { useNavigate } from "react-router-dom";

const ActivityCard = ({
  ref1,
  ref2,
  ref3,
  ref4,
  data1,
  data2,
  data3,
  data4,
  data5,
  data6,
  data7,
  btn,
  bgColor,
  route,
  res,
  storageName,
}) => {
  const navigate = useNavigate();

  return (
    <Box className={styles.recent_activity} sx={{ backgroundColor: bgColor }}>
      <span style={{ color: customTextColor }}>
        <Typography>
          {ref1}:<b> {data1}</b>
        </Typography>
        <Typography>
          {ref2}:<b> {data2}</b>
        </Typography>
        <Typography>
          {ref4}:<b> {data5}</b>
        </Typography>
        <Typography sx={{ marginBottom: "0 !important" }}>
          {ref3}:<b> {data3}</b>
        </Typography>
      </span>
      <span
        style={{ display: "flex", flexDirection: "column", alignItems: "end" }}
      >
        <Typography style={{ color: customTextColor }}>
          {formatDate(data4)}, {formatTime(data4)}
        </Typography>
        <button
          style={{ marginTop: "1.4rem" }}
          onClick={() => {
            navigate(route);
            localStorage.setItem(
              storageName,
              JSON.stringify({ row: res, names: "profile_view" })
            );
          }}
        >
          {btn}
        </button>
      </span>
    </Box>
  );
};

export default ActivityCard;
